import { Modal, Button } from "react-bootstrap";
import "./Call_Now_Expert_Modal.css";
import { IDS } from "../../../../utils/IDS";

function Call_Now_Expert_Modal({ show, handleClose, expert }) {
  const user = expert?.user || {};
  const userDetails = user?.user_details || {};

  const displayData = {
    name: user?.name || "N/A",

    location:
      [userDetails?.state?.name, userDetails?.district?.name]
        .filter(Boolean)
        .join(", ") || "N/A",

    field:
      userDetails?.profession
        ?.map((p) => p?.profession?.name)
        .filter(Boolean)
        .join(", ") || "N/A",

    experience: userDetails?.experience
      ? `${userDetails.experience} Years`
      : "N/A",

    age: userDetails?.dob
      ? new Date().getFullYear() - new Date(userDetails?.dob).getFullYear()
      : "N/A",

    img: user?.profile_pic
      ? `${IDS.IMG_URL}${user.profile_pic}`
      : "/assets/images/banner/banner.png",

    verified: user?.verify_status,

    availability: user?.available_today ? "Available Today" : "Not Available",

    service: user?.free_site_visit ? "Free Site Visit" : "Paid Service",

    phone: user?.mobile_number || "N/A",
  };
  return (
    <Modal
      show={show}
      onHide={handleClose}
      centered
      className="call-now-expert-modal"
    >
      <Modal.Body className="p-2">
        <div className="profile-card-wrapper mb-0">
          <div className="profile-card-body">
            <div className="profile-card-image">
              <img src={displayData?.img} alt={displayData?.name} />
            </div>
            <div className="profile-card-info">
              <div className="profile-card-title">
                <span className="profile-card-name">{displayData?.name}</span>
                {displayData?.verified && (
                  <img
                    src="/assets/images/verified.png"
                    alt="Verified"
                    className="profile-card-badge"
                  />
                )}
              </div>

              <div className="profile-card-location">
                {displayData?.location}
              </div>

              <div className="profile-card-details">
                <div className="profile-card-row">
                  <span className="profile-card-label">Field:-</span>
                  <span className="profile-card-value">
                    {displayData?.field}
                  </span>
                </div>
                <div className="profile-card-row">
                  <span className="profile-card-label">Experience:-</span>
                  <span className="profile-card-value">
                    {displayData?.experience}
                  </span>
                </div>
                <div className="profile-card-row">
                  <span className="profile-card-label">Age:-</span>
                  <span className="profile-card-value">{displayData?.age}</span>
                </div>
              </div>

              {/* <div className="profile-card-status">
                {displayData?.availability}
              </div>
              <div className="profile-card-link">{displayData?.service}</div> */}
            </div>
          </div>
          <div className="phone-number-display-box text-center py-3 border-top mt-2">
            <span
              style={{ fontSize: "22px", fontWeight: "700", color: "#333" }}
            >
              +91 {displayData?.phone}
            </span>
          </div>
        </div>
        <div className="text-center mt-3">
          <Button className="modal-close-pill" onClick={handleClose}>
            Close
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
}
export default Call_Now_Expert_Modal;
